<template>
  <div>
    <VTextField
      v-model="clientTeam.name"
      :label="$t('forms.labels.name')"
      @input="updateData"
    />
    <VCheckbox
      v-model="clientTeam.active"
      :label="$t('forms.labels.active')"
      color="primary"
      @input="updateData"
    />
  </div>
</template>

<script>
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import VCheckbox from '@/components/shared/widgets/forms/VuetifyInputs/VCheckbox';

export default {
    components: {
        VTextField,
        VCheckbox,
    },
    props: {
        populateWith: {
            type: Object,
            default: () => ({ empty: true }),
        },
    },
    data() {
        return {
            clientTeam: {
                name: null,
                active: true,
            },
        };
    },
    created() {
        if (!this.populateWith.empty) this.clientTeam = { ...this.populateWith };
    },
    methods: {
        updateData() {
            this.$emit('sendData', this.clientTeam);
        },
    },
};
</script>
